export class SupplierAuctionOfferListModel {

  auctionId: number;

  itemName?: string;

  itemType?: number;

  offeredAmount?: string;

  offeredPrice?: string;

  remainingTime?: Date;

  auctionDeadline?: Date;

  auctionStartDate?: Date;

  // DODATO ZA POTREBE FRONTA
  auctionEnded?: boolean;
  auctionStarted?: boolean;

  auctionType?: string;

  requestRoundSupplierId?: number;

  requestRoundSupplierStatus?: string;

  auctionUniqueIdentifier?: string;

  requestRoundId: number;

  requestId: number;

// custom-start

  offeredSupplierAmount?: number;
  offeredSupplierPrice?: number;
  isFinished?: boolean;

// custom-end

  constructor() {
  }
}

